export default function(){

  const base = window.location.origin,
      path = window.location.pathname
  let result = ""
  if(path.indexOf('/mx')===0||path.indexOf('/item')===0){
    result = base+path
  }else{
    result = base+"/mx/products/"
  }

  return result
}


// WEBPACK FOOTER //
// ./ixcms/themes/heartlandtan/src/vue-src/base/methods/loginLinkRedirect.js